"use client";

import { CircleNotch } from "@phosphor-icons/react";

import { cn } from "../../lib/utils";

interface ButtonLabelLoaderProps {
  isPending: boolean;
  label?: string;
}

export function ButtonLabelLoader({ isPending, label }: ButtonLabelLoaderProps) {
  return (
    <span className="relative w-full">
      <span className={cn(isPending ? "visible absolute top-[10%] flex w-full items-center justify-center" : "hidden")}>
        <CircleNotch className="mr-1 size-4 animate-spin" />
      </span>
      <span className={cn(isPending ? "invisible" : "visible")}>{label ? label : "Save"}</span>
    </span>
  );
}
